import { render, staticRenderFns } from "./RenseignementClient.vue?vue&type=template&id=6a5469cf&scoped=true"
import script from "./RenseignementClient.vue?vue&type=script&lang=js"
export * from "./RenseignementClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5469cf",
  null
  
)

export default component.exports